import React, {useState} from "react";
import Spinner from "@ui-components/Spinner";
import {BasePromptPageProps} from "@pages/Prompts/types";
import {FormattedMessage} from "react-intl";
import Checkbox from "@ui-components/Checkbox";
import Button from "@ui-components/Button";
import {useHistory} from "react-router-dom";

export const BasePromptPage = ({
  title,
  loading,
  submitting,
  children,
  onConfirm,
  onCancel=undefined,
  conditionsText=undefined,
}: BasePromptPageProps) => {

  // hooks
  const history = useHistory();

  // state
  const [checked, setChecked] = useState(!conditionsText);

  if (loading)
    // @ts-ignore
    return <Spinner />;

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="w-4/5 md:w-2/3 lg:w-1/2 flex flex-col gap-10">
        {/* --------------- HEADER --------------- */}
        <div className="flex flex-col gap-2">
          <p className="text-lg text-gray-600 font-medium ml-0.5">
            Genius Lab Building Platform
          </p>
          <p className="text-4xl font-semibold">
            {title}
          </p>
        </div>
        {/* --------------- CONTENT --------------- */}
        <div className="flex flex-col gap-4 text-base">
          <div>
            {children}
          </div>
          {!!conditionsText && (
            <div className="flex items-center gap-3">
              <Checkbox
                id="chk-confirm"
                name="chk-confirm"
                checked={checked}
                onChange={setChecked}
              />
              <div className="text-xs">
                {conditionsText}
              </div>
            </div>
          )}
        </div>
        {/* --------------- ACCEPT CONDITIONS --------------- */}
        <div className="flex gap-3 justify-between">
          <div className="flex-1">
            {/* @ts-ignore */}
            <Button
              full
              styleType="empty"
              onClick={onCancel ?? (() => history.push('/'))}
              disabled={submitting}
            >
              <FormattedMessage id="cancel" />
            </Button>
          </div>
          <div className="flex-1">
            {/* @ts-ignore */}
            <Button
              full
              onClick={onConfirm}
              disabled={!checked}
              submitting={submitting}
            >
              <FormattedMessage id="confirm" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}